import React from 'react';
import {SetState} from "../redux/reduxhelper";
import {getRandomInt, str_shuffle} from "../tools/helper";

const keyName = 'force_update';
let num = getRandomInt(111111,999999);
let str = str_shuffle('abcdefghijklmnopqrstuvwxyz0123654789-',8);
export const ForceUpdate = SetState(keyName, `${num}-${str}`);